import Vue from "vue";
import VueRouter from "vue-router";
import DashboardPlugin from "./material-dashboard";
import { auth } from "./firebase"
// Plugins
import App from "./App.vue";
import Chartist from "chartist";

// router setup
import routes from "./routes/routes";

// plugin setup
Vue.use(VueRouter);
Vue.use(DashboardPlugin);

// configure router
const router = new VueRouter({
  routes, // short for routes: routes
  linkExactActiveClass: "nav-item active"
});

// global library setup
Object.defineProperty(Vue.prototype, "$Chartist", {
  get() {
    return this.$root.Chartist;
  }
});
let app;
/* eslint-disable no-new */
auth.onAuthStateChanged(() => {
  if (!app) {
    app = new Vue({
      el: "#app",
      render: h => h(App),
      router,
      data: {
        Chartist: Chartist
      }
    });
  }
});
